import { Controller } from "@hotwired/stimulus"
import videojs from "video.js"

export default class extends Controller {
  initialize() {
    this.video = this.element.querySelector("video.video-js")
  }

  connect() {

    videojs(this.video, {
      controls: true,
      autoplay: false,
      preload: "auto",
      fluid: true,
      enableSmoothSeeking: true,
      experimentalSvgIcons: true,
    })
  }
}
